import React, { useState } from 'react';
import styles from './DynamicAttributes.module.css';
import AutoCompleteInput from "./AutoCompleteInput";
import {IoAdd, IoLogOutSharp} from "react-icons/io5";
import {FaTrash} from "react-icons/fa6";
import {RiDeleteBin2Line} from "react-icons/ri";
import {MdAdd, MdDelete} from "react-icons/md";

function DynamicAttributes({ value = [], onChange, candidates = [] }) {
    // Ensure at least one empty row when the component mounts

    /* ---------- Handlers ---------- */

    const handleInputChange = (rowIdx, field, newVal) => {
        const next = value.map((row, i) =>
            i === rowIdx ? { ...row, [field]: newVal } : row
        );
        onChange?.(next);
    };

    const addRow = () => onChange?.([...value, { name: '', value: '' }]);

    const removeRow = index =>
        onChange?.(value.filter((_, i) => i !== index));

    /* ---------- Render ---------- */
    return (
        <div className={styles.container}>
            {value.map((row, idx) => (
                <div key={idx} className={styles.row}>
                    <AutoCompleteInput
                        value={row.name}
                        onChange={v => handleInputChange(idx, 'name', v)}
                        candidates={candidates}
                    />
                    {/*<input*/}
                    {/*    className={styles.input}*/}
                    {/*    type="text"*/}
                    {/*    placeholder="Name"*/}
                    {/*    value={row.name}*/}
                    {/*    onChange={e => handleInputChange(idx, 'name', e.target.value)}*/}
                    {/*/>*/}

                    <input
                        className={`input-text ${styles["input"]}`}
                        type="text"
                        placeholder="Value"
                        value={row.value}
                        onChange={e => handleInputChange(idx, 'value', e.target.value)}
                    />

                    <div className={"fa-icon -smaller"}
                         onClick={() => removeRow(idx)}
                         title={"remover atributo"}
                    >
                        <MdDelete  />
                    </div>
                    {/*<button*/}
                    {/*    className={styles.removeButton}*/}
                    {/*    type="button"*/}
                    {/*    onClick={() => removeRow(idx)}*/}
                    {/*    aria-label={`Remove row ${idx + 1}`}*/}
                    {/*>*/}
                    {/*    &minus;*/}
                    {/*</button>*/}
                </div>
            ))}

            <div
                className={"fa-icon-with-text"}
                onClick={addRow}
            >
                <MdAdd  />
                <div>Adicionar novo atributo</div>
            </div>
        </div>
    );
}

export default DynamicAttributes;
